import _ from 'lodash';
import { pensionInstructionMixin } from './instruction';
import { paymentInstructionMatrix } from '@/app/utils/toolkit/business-rules/pension-payment-instruction/rulesMatrix';

function getNumberOfSelectedAccountsAcrossMembers(members) {
  const membersArr = _.values(members);

  return membersArr.reduce(
    (prev, curr) => prev + _.values(curr.accounts).length,
    0,
  );
}

function getTotalNumberOfAccountTypeAcrossMembers(members, accountType) {
  let numAccounts = 0;
  Object.keys(members).forEach((memberKey) => {
    const member = members[memberKey];
    Object.keys(member.accounts).forEach((accountKey) => {
      const account = member.accounts[accountKey];
      if (account.type === accountType) numAccounts += 1;
    });
  });

  return numAccounts;
}

function getSelectedAccountType(members) {
  let type = '';
  _.forEach(members, (member) => {
    // Look at first acount for its type
    const [account] = _.values(member.accounts);
    if (account) {
      // eslint-disable-next-line prefer-destructuring
      type = account.type;
    }
  });
  return type;
}

export const pensionAddInstructionMixin = {
  mixins: [pensionInstructionMixin],
  computed: {
    isMaxAccounts() {
      // eslint-disable-next-line max-len
      return getNumberOfSelectedAccountsAcrossMembers(this.ruleMembers) === getTotalNumberOfAccountTypeAcrossMembers(this.members, getSelectedAccountType(this.ruleMembers));
    },
    numAccountsType() {
      if (getNumberOfSelectedAccountsAcrossMembers(this.ruleMembers) === 1) return 'single';
      if (this.account === 'All Pension Accounts' || this.account === 'All Accumulation Accounts' || this.isMaxAccounts) return 'all';
      return 'multiple';
    },
    rules() {
      const type = getSelectedAccountType(this.ruleMembers);
      return paymentInstructionMatrix[type.toUpperCase()] || [];
    },
    rulesOutcome() {
      const rules = this.rules
        .filter(rule => rule.accounts.accounts === this.numAccountsType)
        .filter(rule => rule.way.label === this.way)
        .filter(rule => rule.until.label === this.until.selection);

      if (this.extra !== '') {
        return rules.filter(
          rule => rule.extra && rule.extra.label === this.extra,
        );
      }
      return rules;
    },
  },
};

export default pensionAddInstructionMixin;
